module.exports = __webpack_public_path__ + "static/media/IBAA_Tour_Logo_Black_CMYK.52127239.png";